/**
 *
 * Reset Password
 *
 */
import { FC } from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { Input, Form, Button, Card, Row } from 'antd';
import { TextRegular14, TextSemibold20 } from 'styles/typography';
import { UserOutlined } from '@ant-design/icons';
import { RouteConstants } from '../../../../routes';
import { Link } from 'react-router-dom';
import { IResetPasswordFormValues, resetPasswordEnum } from '../../slice/types';
import { useAuthorizationSlice } from '../../slice';
import { useDispatch } from 'react-redux';

interface IProps {}

const RESET_PASSWORD_FORM_ID = 'resetPasswordFormId';

const ResetPassword: FC<IProps> = () => {
  const { t } = useTranslation();

  const { actions } = useAuthorizationSlice();

  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const { primary } = useTheme();

  const handleSubmit = ({ email }: IResetPasswordFormValues) => {
    dispatch(actions.resetPassword(email));
  };

  return (
    <ResetPasswordCard
      bordered={false}
      title={
        <TextSemibold20>
          {t('Auth.ResetPassword.Title', 'Reset password')}
        </TextSemibold20>
      }
      headStyle={{ borderBottom: 'none', textAlign: 'center' }}
    >
      <Form
        name="resetPassword"
        form={form}
        id={RESET_PASSWORD_FORM_ID}
        onFinish={handleSubmit}
      >
        <Form.Item
          name={resetPasswordEnum.email}
          rules={[
            {
              required: true,
              type: 'email',
              message: t(
                'Validation.ShouldBeValidEmail',
                'Should be valid email',
              ),
            },
          ]}
        >
          <Input
            placeholder={t('Auth.ResetPassword.Email', 'Email')}
            size="large"
            prefix={<UserOutlined style={{ color: primary }} />}
          />
        </Form.Item>

        <Form.Item>
          <Button block type="primary" htmlType="submit" size="large">
            {t('Auth.ResetPassword.SubmitChangePassword', 'Change password')}
          </Button>
        </Form.Item>
      </Form>
      <Row justify="center" align="middle">
        <TextRegular14>
          {t('Auth.ResetPassword.RememberPassword', 'Remember your password?')}
        </TextRegular14>
        <Link to={RouteConstants.auth.login}>
          <Button type="link">
            {t('Auth.ResetPassword.LoginHere', 'Login here.')}
          </Button>
        </Link>
      </Row>
    </ResetPasswordCard>
  );
};

const ResetPasswordCard = styled(Card)`
  width: 330px;
`;

export default ResetPassword;
